<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="menu.id === null">{{ 'NEWmenu' | translate }}</span>
            <span *ngIf="menu.id !== null">{{ 'EDITmenu' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="menuForm" id="menuForm" novalidate (ngSubmit)="submitForm(true)"
            [formGroup]="menuForm">
            <input type="hidden" name="id" id="menuId" formControlName="id" />
          
            <!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
           
              <!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="menuTitle" formControlName="title" type="text" pInputText [required]="false"> 
                      <label for="menuTitle" class="">{{ 'TITLE' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
              <!--/p-col-6-->
            </div>
            <!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="menuTitleAr" formControlName="titleAr" type="text" pInputText [required]="false"> 
                      <label for="menuTitleAr" class="">{{ 'TITLEAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
              <!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="menuTitleFr" formControlName="titleFr" type="text" pInputText [required]="false"> 
                      <label for="menuTitleFr" class="">{{ 'TITLEFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
              <!--/p-col-6-->
            </div>
            <!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-anchor"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="menuSlug" formControlName="slug" type="text" pInputText [required]="false"> 
                      <label for="menuSlug" class="">{{ 'SLUG' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
              <!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-anchor"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="menuSlugAr" formControlName="slugAr" type="text" pInputText [required]="false"> 
                      <label for="menuSlugAr" class="">{{ 'SLUGAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
              <!--/p-col-6-->
            </div>
            <!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-anchor"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="menuSlugFr" formControlName="slugFr" type="text" pInputText [required]="false"> 
                      <label for="menuSlugFr" class="">{{ 'SLUGFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
              <!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-image"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="menuPicture" formControlName="picture" type="text" pInputText [required]="false"> 
                      <label for="menuPicture" class="">{{ 'PICTURE' | translate }}</label>
                    </span>
                    <button type="button" pButton pRipple icon="pi pi-folder" styleClass="p-button-info"
                      (click)="openFilerDialog('picture')"></button>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
            
          
              <!--/p-col-6-->
            </div>
            <!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-12">

                <div class="p-field p-col-12">
                    <label for="menuContent" class="">{{ 'CONTENT' | translate }}</label>
                    <ckeditor formControlName="content" [editor]="Editor" id="menuContent" name="content" [config]="editorService.config"></ckeditor>
                </div>

              </div>
              <!--/p-col-12-->
            </div>
            <!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-12">

                <div class="p-field p-col-12">
                    <label for="menuContentAr" class="">{{ 'CONTENTAR' | translate }}</label>
                    <ckeditor formControlName="contentAr" [editor]="Editor" id="menuContentAr" name="contentAr" [config]="editorService.config"></ckeditor>
                </div>

              </div>
              <!--/p-col-12-->
            </div>
            <!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-12">

                <div class="p-field p-col-12">
                    <label for="menuContentFr" class="">{{ 'CONTENTFR' | translate }}</label>
                    <ckeditor formControlName="contentFr" [editor]="Editor" id="menuContentFr" name="contentFr" [config]="editorService.config"></ckeditor>
                </div>

              </div>
              <!--/p-col-12-->
            </div>
            <!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
           
              <!--/p-col-6-->
          
              <!--/p-col-6-->
            </div>
            <!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-control-skip-forward"></i>
                    </span>
                    <span class="p-float-label">
                      <p-calendar inputId="menuStartPublishing" formControlName="startPublishing" [showTime]="true" hourFormat="24" [showIcon]="true" [yearNavigator]="true" [monthNavigator]="true" [required]="false" yearRange="1900:2030" [stepHour]="1" [stepMinute]="15" [stepSecond]="0"></p-calendar>
                      <label for="menuStartPublishing" class="">{{ 'STARTPUBLISHING' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
              <!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-control-skip-backward"></i>
                    </span>
                    <span class="p-float-label">
                      <p-calendar inputId="menuEndPublishing" formControlName="endPublishing" [showTime]="true" hourFormat="24" [showIcon]="true" [yearNavigator]="true" [monthNavigator]="true" [required]="false" yearRange="1900:2030" [stepHour]="1" [stepMinute]="15" [stepSecond]="0"></p-calendar>
                      <label for="menuEndPublishing" class="">{{ 'ENDPUBLISHING' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
              <!--/p-col-6-->
            </div>
            <!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-calendar"></i>
                    </span>
                    <span class="p-float-label">
                      <p-calendar inputId="menuPublishDate" formControlName="publishDate" [showTime]="true" hourFormat="24" [showIcon]="true" [yearNavigator]="true" [monthNavigator]="true" [required]="true" yearRange="1900:2030" [stepHour]="1" [stepMinute]="15" [stepSecond]="0"></p-calendar>
                      <label for="menuPublishDate" class="req">{{ 'PUBLISHDATE' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div
                  *ngIf="menuForm.controls['publishDate'].invalid && (menuForm.controls['publishDate'].dirty || menuForm.controls['publishDate'].touched)"
                  class="alert alert-danger">
                  <ng-container *ngIf="menuForm.controls['publishDate'].errors !== null">
                  <div *ngIf="menuForm.controls['publishDate'].errors.required">
                   {{ 'PUBLISHDATEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div>
      
              <!--/p-col-6-->
            </div>
            <!--/p-fluid p-grid-->
        
            <!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12" [hidden]="common.currentUser.roles.join('').indexOf('ROLE_ADMIN_PUBLISHER') === -1" >
                  <label for="menuStatus" class="req">{{ 'STATUS' | translate }}</label>
                  <div class="p-formgroup-inline">
                    <div class="p-field-checkbox"
                      *ngFor="let option of menusColumnsService.statusesOptions; let i = index">
                      <p-radioButton inputId="menuStatus_{{ i }}" formControlName="status" name="status"
                        [value]="option.value"></p-radioButton>
                      <label for="menuStatus_{{ i }}">{{ option.label | translate }}</label>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="menuForm.controls['status'].invalid && (menuForm.controls['status'].dirty || menuForm.controls['status'].touched)"
                  class="alert alert-danger">
                  <ng-container *ngIf="menuForm.controls['status'].errors !== null">
                  <div *ngIf="menuForm.controls['status'].errors.required">
                   {{ 'STATUSREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div>
              <!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12" [hidden]="common.currentUser.roles.join('').indexOf('ROLE_ADMIN_EXPERT') === -1" >
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-print"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="menuTotalPrints" formControlName="totalPrints" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="menuTotalPrints" class="">{{ 'TOTALPRINTS' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
              <!--/p-col-6-->
            </div>
            <!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12" [hidden]="common.currentUser.roles.join('').indexOf('ROLE_ADMIN_EXPERT') === -1" >
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-eye"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="menuTotalHits" formControlName="totalHits" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="menuTotalHits" class="">{{ 'TOTALHITS' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
              <!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12" [hidden]="common.currentUser.roles.join('').indexOf('ROLE_ADMIN_EXPERT') === -1" >
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-comments"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="menuTotalComments" formControlName="totalComments" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="menuTotalComments" class="">{{ 'TOTALCOMMENTS' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
              <!--/p-col-6-->
            </div>
            <!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12" [hidden]="common.currentUser.roles.join('').indexOf('ROLE_ADMIN_EXPERT') === -1" >
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-star-half-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="menuTotalRatings" formControlName="totalRatings" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="menuTotalRatings" class="">{{ 'TOTALRATINGS' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
              <!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12" [hidden]="common.currentUser.roles.join('').indexOf('ROLE_ADMIN_EXPERT') === -1" >
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-pie-chart"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="menuAverageRatings" formControlName="averageRatings" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [step]="0.1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="menuAverageRatings" class="">{{ 'AVERAGERATINGS' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
              <!--/p-col-6-->
            </div>
            <!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12" [hidden]="common.currentUser.roles.join('').indexOf('ROLE_ADMIN_EXPERT') === -1" >
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-thumbs-down"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="menuTotalLikes" formControlName="totalLikes" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="menuTotalLikes" class="">{{ 'TOTALLIKES' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
              <!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12" [hidden]="common.currentUser.roles.join('').indexOf('ROLE_ADMIN_EXPERT') === -1" >
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-thumbs-up"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="menuTotalDislikes" formControlName="totalDislikes" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="menuTotalDislikes" class="">{{ 'TOTALDISLIKES' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
              <!--/p-col-6-->
            </div>
            <!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12" [hidden]="common.currentUser.roles.join('').indexOf('ROLE_ADMIN_EXPERT') === -1" >
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-bookmark"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="menuTotalBookmarks" formControlName="totalBookmarks" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="menuTotalBookmarks" class="">{{ 'TOTALBOOKMARKS' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div>
              <!--/p-col-6-->
              
              <!--/p-col-6-->
            </div>
            <!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
            
              <!--/p-col-6-->
           
              <!--/p-col-6-->
            </div>
            <!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKmenuS' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="menu.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary"
                  [disabled]="!menuForm.valid || disableSubmit">
                  <!--  [disabled]="menuForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!menuForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div>
    <!--/p-col-12-->
  </div>
  <!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div>
<!--/container-fluid container-fullw-->
<!-- end: FORM -->
